var render = function (_h,_vm) {var _c=_vm._c;return (_vm.$options.getIcon(((_vm.props.name) + "Icon")))?_c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":("#" + (_vm.$options.getIcon(((_vm.props.name) + "Icon")).id))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }